import { storage, db, auth } from "../../firebase";
import { getTwoRandomInt } from "../../function/common";
import { fetchCleaningPlacesAction } from "./actions";

const cleaningRef = db.collection('cleaning');
const userRef = db.collection('users');

export const fetchCleaningPlaces = () => {
    return async (dispatch) => {
        // NOTE:詳しくはmainPage/operations.jsを参照
        const SUBJECT_COUNT = 7

        var randomNumber = getTwoRandomInt(1, SUBJECT_COUNT);
        
        // 最初にオブジェクトを空で定義する
        var cleaningTwoPlaces = [];
        for (let i = 0; i < 2; i++) {
            let query = cleaningRef.doc('subject' + randomNumber[i]);
            // Firestore Database
            query.get()
                .then((subject) => {
                    cleaningTwoPlaces.push(subject.data());
                    // NOTE:dispatchをthenの外で実行させるとうまく行かなかった。
                    // 多分For分文の処理に追い抜かされて非同期外のDispatchをしてしまったのだと思う。
                    if (i == 1) {
                        dispatch(fetchCleaningPlacesAction(cleaningTwoPlaces))

                        auth.onAuthStateChanged((user) => {
                            if (!user) {
                                return
                            }
                            // 毎日掃除ガチャを回すたびに+1されていく
                            userRef.doc(user.uid).get()
                                .then((res) => {
                                    // var counter = res.data().counter
                                    console.dir(res)
                                    var updateDate = new Date(res.data().updateYMD.seconds * 1000)
                                    // NOTE:Timestamp --> yyyyMMddを取得する
                                    var updateYMD = updateDate.getFullYear()
                                                   + ('0' + (updateDate.getMonth() + 1)).slice(-2)
                                                   + ('0' + updateDate.getDate()).slice(-2)
                                    var currentDate = new Date()
                                    var currentYMD = currentDate.getFullYear()
                                                   + ('0' + (currentDate.getMonth() + 1)).slice(-2)
                                                   + ('0' + currentDate.getDate()).slice(-2)

                                    if (currentYMD > updateYMD) {
                                        userRef.doc(user.uid).set({
                                            counter: res.data().counter + 1,
                                            updateYMD: currentDate
                                        })
                                            .then(() => {
                                                // TODO:処理終了したことをReduxに教えてあげる必要あり
                                                console.log("ok")
                                            })
                                            .catch((err) => {
                                                alert(err)
                                            })
                                    }
                                })
                        })
                    }
                })
                .catch((e) => console.log('Errors while firestore connecting => ', e));
        }
        
    }
}